import React from 'react';
import { UsersIcon, ShieldIcon, HeartHandshakeIcon } from 'lucide-react';
export const CommunitySection: React.FC = () => {
  return <section className="py-16 md:py-24 bg-white" data-id="element-44">
      <div className="section-container" data-id="element-45">
        <div className="text-center mb-12" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper mb-4" data-id="element-47">
            Healing together.
          </h2>
          <p className="text-lg text-plum-gray max-w-2xl mx-auto" data-id="element-48">
            Our group therapy sessions connect people who understand your
            journey. You'll build support, accountability, and shared hope.
          </p>
        </div>
        <div className="flex justify-center mb-12" data-id="element-49">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1sGLLebNv9nAaXji7Vyd4Y/growth_elements_purple.svg" alt="Stylized plant with purple leaves and coral accent nodes, representing community growth and interconnected healing" className="w-full max-w-md" data-id="element-50" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-51">
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-52">
            <div className="w-14 h-14 rounded-full bg-mist-sage/30 flex items-center justify-center mb-4" data-id="element-53">
              <UsersIcon className="text-deep-juniper" size={28} data-id="element-54" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-55">
              Shared Stories
            </h3>
            <p className="text-plum-gray" data-id="element-56">
              Connect with others who truly understand. Learning through shared
              experiences creates deeper healing and lasting bonds.
            </p>
          </div>
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-57">
            <div className="w-14 h-14 rounded-full bg-sandstone/50 flex items-center justify-center mb-4" data-id="element-58">
              <ShieldIcon className="text-deep-juniper" size={28} data-id="element-59" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-60">
              Safe Circles
            </h3>
            <p className="text-plum-gray" data-id="element-61">
              Our expert therapists facilitate each group, ensuring a
              structured, respectful environment where everyone feels secure.
            </p>
          </div>
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-62">
            <div className="w-14 h-14 rounded-full bg-apricot/30 flex items-center justify-center mb-4" data-id="element-63">
              <HeartHandshakeIcon className="text-deep-juniper" size={28} data-id="element-64" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-65">
              Continuous Motivation
            </h3>
            <p className="text-plum-gray" data-id="element-66">
              Group members provide accountability and encouragement between
              sessions, helping you stay connected to your healing journey.
            </p>
          </div>
        </div>
      </div>
    </section>;
};